import { ref, onMounted, onUnmounted } from "vue";

export function useResponsiveWidth(options = {}) {
  const {
    minWidth = 200,
    maxWidth = 700,
    breakpoint = 768, // Standard tablet breakpoint
    offset = 300,
  } = options;

  const inputWidth = ref(minWidth);

  const updateInputWidth = () => {
    const windowWidth = window.innerWidth;
    if (windowWidth < breakpoint) {
      inputWidth.value = minWidth;
    } else if (windowWidth > maxWidth + offset) {
      inputWidth.value = maxWidth;
    } else {
      inputWidth.value = windowWidth - offset;
    }
  };

  onMounted(() => {
    window.addEventListener("resize", updateInputWidth);
    updateInputWidth(); // initial update
  });

  onUnmounted(() => {
    window.removeEventListener("resize", updateInputWidth);
  });

  return {
    inputWidth,
  };
}
